import { render, staticRenderFns } from "./vipPage2.vue?vue&type=template&id=6cf4f92a&scoped=true&"
import script from "./vipPage2.vue?vue&type=script&lang=js&"
export * from "./vipPage2.vue?vue&type=script&lang=js&"
import style0 from "./vipPage2.vue?vue&type=style&index=0&id=6cf4f92a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf4f92a",
  null
  
)

export default component.exports